import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serverList } from "@/api/gmToolNew/gmToolNew";
import { vipCallLogAdd, vipCallLogUpdate } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage, gmToolNewCom } from "@/mixins/index";
import { jsonDiff } from "diff/lib/diff/json";
export default {
  mixins: [gmToolNew, gmToolNewPage, gmToolNewCom],
  data: function data() {
    return {
      dialogShow: false,
      paramsData: {
        id: "",
        user_id: "",
        user_name: "",
        contact_time: "",
        server_id: "",
        vip_class: ""
      },
      rules: {
        user_id: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        user_name: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        vip_class: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        contact_time: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this = this;

      this.paramsData = _objectSpread({
        server_id: ""
      }, data);

      if (data.id) {
        this.paramsData.server_id = this.paramsData.server_id ? parseInt(this.paramsData.server_id) : '';
        this.serverChannel.forEach( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(i) {
            var query;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return serverList({
                      server_channel: i.value,
                      env_id: _this.propsData.env_id
                    });

                  case 2:
                    query = _context.sent;

                    if (query.code == 200 && query.data.findIndex(function (j) {
                      return j.serverID == data.server_id;
                    }) > -1) {
                      _this.server_channel = i.value;
                      _this.serverListYJ = query.data;
                    }

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }

      this.dialogShow = true;
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      this.paramsData = {
        id: "",
        user_id: "",
        user_name: "",
        contact_time: "",
        server_id: "",
        vip_class: ""
      };
      this.server_channel = '';
      this.serverListYJ = [];
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.paramsData));
          var reqFn = data.id ? vipCallLogUpdate : vipCallLogAdd;
          reqFn(_objectSpread(_objectSpread({}, data), {}, {
            game_id: _this2.rawData.game_id
          }, _this2.propsData)).then(function (res) {
            if (res.code == 200 || res.status == 200) {
              _this2.$message({
                message: _this2.$t('operationSuccess'),
                type: "success"
              });

              _this2.dialogShow = false;

              _this2.$emit("change");
            }
          });
        }
      });
    }
  }
};